/* QUIDLAB CUSTOM THEME JAVASCRIPT */

// Mobile Navigation Toggle
window.toggleMenu = function() {
  const ham = document.getElementById('ham');
  const mnav = document.getElementById('mnav');
  if (ham) ham.classList.toggle('op');
  if (mnav) mnav.classList.toggle('op');
}

// Hero Slider Initializer
window.initQuidlabHeroSlider = function() {
  const heroes = document.querySelectorAll('.quidlab-body .hero');
  heroes.forEach((hero) => {
    if (hero.classList.contains('initialized')) return;
    hero.classList.add('initialized');

    const slides = hero.querySelectorAll('.hslide');
    const dots = hero.querySelectorAll('.hd');
    if (!slides.length) return;

    const autoRotate = hero.getAttribute('data-autorotate') === 'true';
    const speed = parseInt(hero.getAttribute('data-speed'), 10) || 5000;
    let si = 0;
    let sliderInterval;

    function setSlide(i) {
      si = i;
      slides.forEach((slide, idx) => {
        slide.classList.toggle('act', idx === i);
      });
      dots.forEach((dot, idx) => {
        dot.classList.toggle('act', idx === i);
      });
    }

    function startAutoRotate() {
      if (autoRotate && slides.length > 1) {
        stopAutoRotate();
        sliderInterval = setInterval(() => {
          setSlide((si + 1) % slides.length);
        }, speed);
      }
    }

    function stopAutoRotate() {
      if (sliderInterval) {
        clearInterval(sliderInterval);
        sliderInterval = null;
      }
    }

    const prevBtn = hero.querySelector('.harrow--prev');
    const nextBtn = hero.querySelector('.harrow--next');

    if (prevBtn) {
      prevBtn.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        stopAutoRotate();
        setSlide((si - 1 + slides.length) % slides.length);
        startAutoRotate();
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        stopAutoRotate();
        setSlide((si + 1) % slides.length);
        startAutoRotate();
      });
    }

    dots.forEach((dot, idx) => {
      dot.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        stopAutoRotate();
        setSlide(idx);
        startAutoRotate();
      });
    });

    startAutoRotate();
  });
}

// Stats Counter
window.initQuidlabStats = function(c1, c2, c3, c4) {
  const stin = document.getElementById('stin');
  if (!stin) return;
  const statsObs = new IntersectionObserver(([e]) => {
    if (!e.isIntersecting) return;
    statsObs.disconnect();
    
    const config = [
      ['sc1', c1 || 20, false],
      ['sc2', c2 || 4.8, true],
      ['sc3', c3 || 4, false],
      ['sc4', c4 || 100, false]
    ];
    
    config.forEach(([id, end, isF]) => {
      const el = document.getElementById(id);
      if (!el) return;
      let cur = 0;
      const step = end / 55;
      const t = setInterval(() => {
        cur = Math.min(cur + step, end);
        el.textContent = isF ? cur.toFixed(1) : Math.floor(cur);
        if (cur >= end) clearInterval(t);
      }, 16);
    });
  }, { threshold: 0.3 });
  statsObs.observe(stin);
}

// FAQ Accordion
window.toggleFaq = function(element) {
  const fq = element.closest('.fq');
  if (fq) {
    fq.classList.toggle('op');
  }
}

// Product Details Gallery
window.initQuidlabProductGallery = function(imgsArray) {
  const c = document.getElementById('gthumbs');
  const m = document.getElementById('gMain');
  if (!c || !m || !imgsArray || !imgsArray.length) return;
  
  c.innerHTML = '';
  let curImg = 0;
  
  imgsArray.forEach((src, i) => {
    const d = document.createElement('div');
    d.className = 'gt' + (i === 0 ? ' act' : '');
    d.innerHTML = `<img src="${src}" alt="product thumbnail">`;
    d.onclick = () => setImg(i);
    c.appendChild(d);
  });
  
  window.setImg = function(i) {
    curImg = i;
    m.style.opacity = '0';
    setTimeout(() => {
      m.src = imgsArray[i];
      m.style.opacity = '1';
    }, 220);
    document.querySelectorAll('.gt').forEach((t, j) => t.classList.toggle('act', j === i));
  }
  
  let slideTimer = setInterval(() => {
    setImg((curImg + 1) % imgsArray.length);
  }, 3000);
  
  c.addEventListener('click', () => clearInterval(slideTimer));
}

// Toast System
window.showToast = function(message) {
  const toast = document.getElementById('toast');
  const msgSpan = document.getElementById('tmsg');
  if (toast && msgSpan) {
    msgSpan.textContent = message;
    toast.classList.add('sh');
    setTimeout(() => {
      toast.classList.remove('sh');
    }, 2800);
  }
}

// Global AJAX Add to Cart interceptor
document.addEventListener('submit', function(e) {
  if (e.target.classList.contains('quidlab-add-to-cart-form')) {
    e.preventDefault();

    const btn = e.target.querySelector('.pcadd');
    if (btn) btn.classList.add('loading');

    let sectionsToBundle = [];
    document.documentElement.dispatchEvent(
      new CustomEvent('cart:grouped-sections', { bubbles: true, detail: { sections: sectionsToBundle } })
    );

    const formData = new FormData(e.target);
    if (sectionsToBundle.length) {
      formData.append("sections", sectionsToBundle.join(','));
      formData.append("sections_url", window.location.pathname);
    }

    fetch('/cart/add', {
      method: 'POST',
      headers: {
        'Accept': 'application/javascript',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: formData
    })
    .then(response => response.json())
    .then(res => {
      if (btn) btn.classList.remove('loading');
      
      // Trigger Minimog cart events to refresh & slide open the cart drawer
      if (window.MinimogEvents && window.MinimogTheme) {
        window.MinimogEvents.emit(window.MinimogTheme.pubSubEvents.cartUpdate, { cart: res });
      }
      document.dispatchEvent(new CustomEvent('cart:refresh', {
        detail: { open: true }
      }));
      
      const itemTitle = (res.items && res.items[0]) ? res.items[0].product_title : (res.product_title || 'Item');
      if (typeof window.showToast === 'function') {
        window.showToast(itemTitle + ' added ✓');
      }
    })
    .catch(error => {
      if (btn) btn.classList.remove('loading');
      console.error('Error adding to cart:', error);
    });
  }
});
